import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { UserEditView } from '@/modules/users'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/users/edit/$userId')({
  component: UserEditView,
  head: () => getMetaWithPageTitle([i18n.t('title.edit-user', { ns: 'users' })])
})
